import React from "react";

export function useFocusFirstInput(withinElementID: string) {

    React.useLayoutEffect(function add() {

        if (!withinElementID) return;

        let hTimeout: any = setTimeout(() => {

            hTimeout = null;

            const within = document.getElementById(withinElementID);
            if (!within) return;
            
            const controls = within.getElementsByClassName("form-control");
            if (controls.length > 0) {
                for(var i=0;i<controls.length;i++) {
                    const el = controls[i] as HTMLElement;
                    const tagName = el.tagName.toLowerCase();
                    if (tagName === "input") {
                        el.focus();
                    } else {
                        // ignore and check next
                        continue;
                    }

                    if (tagName === "input") {
                        const input = el as HTMLInputElement;
                        input.setSelectionRange(0, input.value.length);
                    }

                    break;
    
                }
            }

        }, 50);

        return function remove() {
            if (hTimeout) clearTimeout(hTimeout);
        };
    }, [withinElementID]);

}